import { atom } from "jotai";

export const categoryAtom = atom(null);
export const subCategoryAtom = atom(null);
export const categoryItemAtom = atom(null);
export const cataloguesAtom = atom(null);
export const cataloguesProductsPages = atom(1);
export const editAttributeId = atom([]);
export const savedOrderTablePage = atom(1);
export const savedProductTablePage = atom(1);
export const savedStockTablePage = atom(1);
export const savedUserTablePage = atom(1);
export const savedUserReportTablePage = atom(1);

export const orderCount = atom(false);


